var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "accordion-list"
  }, [_vm._v("\n    " + _vm._s(_vm.expandedItems) + "\n    "), _c('expandable-box', {
    attrs: {
      "expanded": _vm.expandedItems[0]
    },
    on: {
      "click": function($event) {
        _vm.expand(0)
      }
    }
  }), _vm._v(" "), _c('expandable-box', {
    attrs: {
      "expanded": _vm.expandedItems[1]
    },
    on: {
      "click": function($event) {
        _vm.expand(1)
      }
    }
  }), _vm._v(" "), _c('expandable-box', {
    attrs: {
      "expanded": _vm.expandedItems[2]
    },
    on: {
      "click": function($event) {
        _vm.expand(2)
      }
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-da02485e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/extract-loader/lib/extractLoader.js!./node_modules/html-loader?{"interpolate":true,"attrs":[":url","link:href","source:src"]}!./src/components/accordion-list/accordion-list.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-da02485e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/extract-loader/lib/extractLoader.js!./node_modules/html-loader/index.js?{"interpolate":true,"attrs":[":url","link:href","source:src"]}!./src/components/accordion-list/accordion-list.vue
// module chunks = index